<template>
    <div>
        <PageHeader :linkto="'/Sales/Dashboard'" :linkttitle="'返回'" title="我的夥伴"></PageHeader>

        <b-container>

            <b-input-group
                    class="mb-3"
                    prepend="搜尋客戶"
                    size="md"
            >
                <b-form-input
                        v-model="invitecode"
                        type="text"
                        maxlength="10"
                        required
                        placeholder="輸入手機號碼"
                        @change="checkvalue('invitecode')"
                ></b-form-input>
                <b-input-group-append>
                    <b-button text="Button" variant="success" @click="searchClient">搜尋</b-button>
                </b-input-group-append>
            </b-input-group>

            <b-card v-if="searchview" header="搜索結果" class="text-center shadow-lg m-2">
                <div v-if="searchempty">
                    {{searchresult}}
                </div>

                <b-row v-else align-v="center">
                    <b-col>
                        姓名:
                        {{searchresult.first_name + searchresult.last_name }}
                    </b-col>
                    <b-col>
                        電話:
                        {{searchresult.username }}
                    </b-col>
                    <b-col cols="12" class="mt-3" >
                       <b-button text="Button" variant="success" class="shadow" block  @click="inviteClient"><b-icon-plus-circle></b-icon-plus-circle> 點擊綁定客戶</b-button>
                    </b-col>
                </b-row>


            </b-card>
            <hr>
            <b-card no-body class="overflow-hidden p-2 mb-2">
                <h5 class="m-2">已綁定夥伴</h5>
                <b-table striped hover :items="items" :fields="fields" :busy="isBusy" stacked="md">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <!--<template v-slot:cell(send_status)="row">-->
                        <!--{{ getSendStatus(row.item.send_status)}}-->
                    <!--</template>-->
                    <!--<template v-slot:cell(plan)="row">-->
                        <!--<b-form-select size="sm" v-model="items[row.index].plan" :options="options"-->
                                       <!--:disabled="row.item.send_status == '1'"></b-form-select>-->
                    <!--</template>-->
                    <!--<template v-slot:cell(action)="row">-->
                        <!--<b-button-group>-->
                            <!--<b-button v-if="row.item.send_status !== '1'"  @click="sendPlan(row.item)"-->
                                      <!--variant="success">傳送方案-->
                            <!--</b-button>-->
                            <!--<b-button v-if="row.item.send_status == '1' && row.item.status == '0'" size="sm"-->
                                      <!--variant="primary" @click="delInviterPlan(row.item)">收回-->
                            <!--</b-button>-->
                            <!--<p v-if="row.item.send_status == '1' && row.item.status == '1'">已付款</p>-->
                        <!--</b-button-group>-->
                    <!--</template>-->
                </b-table>
            </b-card>
            <b-card header="我的銷售業務夥伴" class="text-center" border-variant="primary"
                    header-bg-variant="primary"
                    header-text-variant="white">
                <b-table striped hover :busy="teamload" :items="teamData" :fields="teamfields" stacked="md">

                    <template v-slot:table-busy>
                        <div class="text-center text-success my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(show_details)="row">
                        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                            {{ row.detailsShowing ? '關閉' : '查看'}} 會員資料
                        </b-button>

                    </template>
                    <template v-slot:cell(sales_lv)="row">
                        {{ salesName(row.item.sales_lv) }}

                    </template>
                    <template v-slot:cell(client)="row">
                        {{ row.item.client.length }}

                    </template>
                    <template v-slot:cell(team)="row">
                        {{ row.item.team.length }}

                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right"><b>會員資格狀態</b></b-col>
                                <b-col>{{ row.item.memberOrder.status==1?'有效':'過期' }}</b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right"><b>會員到期日期</b></b-col>
                                <b-col>{{ row.item.memberOrder.end_date }}</b-col>
                            </b-row>
                        </b-card>
                    </template>
                </b-table>
            </b-card>
        </b-container>
    </div>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import { toastsModel, alertModel } from '@/service/commuse'
import {mapState} from 'vuex'

export default {
  name: 'MySales',
  components: {PageHeader},
  data () {
    return {
      selected: null,
      invitecode: '',
      invitecode_check: false,
      searchview: false,
      searchempty: false,
      searchresult: '',

      options: [{value: null, text: '請選擇'}],

      fields: [
        {
          key: 'numid',
          label: '序號',
          sortable: true
        },
        {
          key: 'name',
          label: '姓名',
          sortable: false
        },
        {
          key: 'username',
          label: '手機',
          sortable: true,
        },
        // {
        //   key: 'plan',
        //   label: '方案',
        //   sortable: true,
        // },
        // {
        //   key: 'send_status',
        //   label: '狀態',
        //   sortable: true,
        // },
        // {
        //   key: 'action',
        //   label: '動作',
        //   sortable: true,
        // },
      ],
      items: [],
      itemcheck: false,
      teamData: [],
      teamload: false,
      teamfields: [
        {
          key: 'fullname',
          label: '姓名',
          sortable: true
        },
        {
          key: 'username',
          label: '帳號',
          sortable: false
        },
        {
          key: 'sales_lv',
          label: '業務等級',
          sortable: false
        },
        {
          key: 'salesbind_date',
          label: '業務加入時間',
          sortable: false
        },
        {
          key: 'client',
          label: '客戶人數',
          sortable: false
        },
        {
          key: 'team',
          label: '業務人數',
          sortable: false
        },
        {
          key: 'show_details',
          label: '會員資訊',
        },

      ],
      isBusy: false,

    }
  },
  computed: { ...mapState(['profiledata']),},
  created () {
    this.$store.dispatch('actionGetCheckSales', {}).catch((res) => { this.$router.push('/home')})
  },
  mounted () {
    this.load()
    this.loadData()
    this.getSalesTeam()
  },
  methods: {
    load () {
      this.$store.dispatch('actionSalesPlan', {provider: 1, plantype: 2}).then((res) => {
        res.data.forEach(element => {
          this.options.push({value: element.product_id, text: element.product_name})
        })
      })
    },
    loadData () {
      let d = new Date()
      this.$store.dispatch('actionMyInviteClient', {
        year: d.getFullYear(),
        month: d.getMonth(),
        day: 'T',
        forwho: 'S'
      }).then((res) => {
        this.items = []
        let num = 0
        res.data.listdata.forEach(element => {
          let User = element.user_data
          num += 1
          this.items.push({
            numid: num,
            id: element.id,
            name: User.first_name + User.last_name,
            phone: User.phone,
            username: User.username,
            invite: User.invite_num,
            plan: element.puid,
            uuid: User.uuid,
            send_status: element.send_status,
            status: element.status,
          },)
        })
      })
    },
    allSetPlan () {
      console.log(this.items)

      for (let i = 0; i < this.items.length; i++) {
        if (this.selected !== null) {
          if (this.items[i]['status'] == 0 && (this.items[i]['send_status'] == 0 || this.items[i]['send_status'] == 2)) {
            this.items[i]['plan'] = this.selected
          }
        }

      }

    },
    checkvalue (way) {
      switch (way) {
        case 'invitecode':
          if (this.invitecode.length == 0) {
            this.invitecode_check = false
          } else {
            this.invitecode_check = true
          }
          break
        case 'allitem':

          let countTotal = 0
          this.itemcheck = false
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i]['plan'] === '') {
              countTotal = countTotal + 1
              this.itemcheck = false
            }
          }
          if (countTotal == 0) {
            this.itemcheck = true
          }
          break

        case 'item':
          for (let i = 0; i < this.items.length; i++) {
            this.itemcheck = true
            if (this.items[i]['plan'] == '') {
              this.itemcheck = false
            }

          }
          break
      }

    },
    searchClient () {
      this.checkvalue('invitecode')

      if (this.invitecode_check == true
      ) {
        this.$store.dispatch('actionSearchClient', {
          phone: this.invitecode
        }).then((res) => {

          this.searchview = true
          this.searchresult = res.data
          this.searchempty = false

        }).catch((res) => {
          this.searchempty = true
          this.searchview = true
          this.searchresult = res.message
          this.invitecode = ''
        })
      }

    },
    inviteClient () {
      this.$store.dispatch('actionInviteClient', {
        phone: this.invitecode,
        type: 'S'
      }).then((res) => {
        this.searchempty = false
        this.searchview = false
        this.searchresult = ''
        this.invitecode = ''
        alertModel(this, '系統訊息', res.message)
        this.loadData()
      }).catch((res) => {
        alertModel(this, '系統訊息', res.message)
      })
    },
    sendPlan (data) {

      if (data.plan !== '') {
        this.isBusy = true
        this.$store.dispatch('actionSendPlanToClient', {
          send_group: data,
          type: 'S'
        }).then((res) => {

          let resdata = res.data
          if (resdata.ok == 1) {
            alertModel(this, '系統訊息', '完成發送').then(() => {
              this.loadData()
            })

          } else {
            alertModel(this, '系統訊息', resdata.errmsg).then(() => {

            })
          }

          this.isBusy = false
        }).catch((res) => {
          toastsModel(this, res.message)
          this.isBusy = false
        })
      } else {
        toastsModel(this, '請選擇發送方案')
      }

    },
    sendAllPlan (data) {

      this.checkvalue('allitem')
      if (this.itemcheck) {
        this.isBusy = true

        this.$store.dispatch('actionSendPlanToClient', {
          send_group: data,
          type: 'S'
        }).then((res) => {
          alertModel(this, '系統訊息', '完成發送')
          this.loadData()
          this.isBusy = false
        }).catch((res) => {
          toastsModel(this, res.message)
          this.isBusy = false
        })
        this.itemcheck = false
      } else {
        if (this.items.length > 0) {
          toastsModel(this, '請選擇發送方案')
        } else {
          toastsModel(this, '未邀請客戶')
        }
      }

    },
    getSalesTeam () {
      this.teamload = true
      this.$store.dispatch('actionGetMySalesTeam', {})
        .then((res) => {
          let data = res.data
          this.teamData = data
          this.teamload = false
        }).catch((res) => {
        this.teamload = false
      })
    },
    delInviterPlan (item) {

      this.isBusy = true

      this.$store.dispatch('actionReturnInviter', {
        id: item.id
      })
        .then((res) => {
          this.loadData()
          this.isBusy = false
        }).catch((res) => {
        this.isBusy = false

      })
    },
    getSendStatus (num) {
      let str = ' '
      switch (num) {
        case '0':
          str = '未發送'
          break
        case '1':
          str = '已發送'
          break
        case '2':
          str = '已收回'
          break

      }
      return str

    },
    salesName (sales) {
      let Name = ''
      switch (sales) {
        case '1':
          Name = ''
          break
        case '2':
          Name = '業務階級'
          break
        case '3':
          Name = '代理階級'
          break
        case '4':
          Name = '股東階級'
          break

      }

      return Name
    }
  }
}
</script>
